// extracted by mini-css-extract-plugin
export default {"Session_container":"BestDealSection_Session_container__V7db6","BestDeal_passSlide":"BestDealSection_BestDeal_passSlide__536SI"};